export interface DropdownOption {
  category: string;
  option: string;
}

//////////////////////////////////////////////////////////////////
// Determine if the dropdownOptions prop is an array of strings or objects
//////////////////////////////////////////////////////////////////

export const isDropdownOptionsArrayOfObjects = (
  array: any[]
): array is DropdownOption[] => {
  return array.some(
    item => typeof item === 'object' && 'category' in item && 'option' in item
  );
};

//////////////////////////////////////////////////////////////////
// Group options by category if applicable
//////////////////////////////////////////////////////////////////
// Input: [{ category: 'Fruits', option: 'Apple' },
//         { category: 'Fruits', option: 'Banana' },
//         { category: 'Vegetables', option: 'Carrot' }]
//
// Output: { 'Fruits': ['Apple', 'Banana'],
//           'Vegetables': ['Carrot'] }
//////////////////////////////////////////////////////////////////

export const groupOptionsByCategory = (options: DropdownOption[]) =>
  isDropdownOptionsArrayOfObjects(options) &&
  options.reduce(
    (acc, { category, option }) => {
      acc[category] = acc[category] ? [...acc[category], option] : [option];
      return acc;
    },
    {} as Record<string, string[]>
  );
